import React from 'react';
import './Chart.css';

const Chart = ({ title }) => {
  // Mock data - in a real app you would use a charting library
  const data = [30, 45, 60, 35, 70, 50, 80];
  const maxValue = Math.max(...data);
  
  return (
    <div className="chart-container">
      <div className="chart-header">
        <h3 className="chart-title">{title}</h3>
        <select className="chart-period">
          <option>Last 7 days</option>
          <option>Last month</option>
          <option>Last year</option>
        </select>
      </div>
      <div className="chart">
        <div className="chart-bars">
          {data.map((value, index) => (
            <div 
              key={index}
              className="chart-bar"
              style={{ height: `${(value / maxValue) * 100}%` }}
            ></div>
          ))}
        </div>
        <div className="chart-labels">
          {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
            <span key={day}>{day}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Chart;